import React from 'react';
import Confirm from '../../CustomComponents/confirm';

export default function template() {
    let warning = null,
        expire = null;

    if (this.state.ui === this.uiStates.WARNING) {
        warning = (
            <Confirm
                cancelLabel={this.l10n('SESSION_CANCEL_BTN')}
                submitLabel={this.l10n('SESSION_RESET_BTN')}
                closeAvailable={false}
                onSubmit={this.reset}
                onCancel={this.abortSession}
            >
                {this.l10n('SESSION_WARNING')}
            </Confirm>
        );
    }

    if (this.state.ui === this.uiStates.EXPIRE) {
        expire = (
            <Confirm
                submitLabel={this.l10n('SESSION_PUBLIC_EXPIRE_BTN')}
                closeAvailable
                onSubmit={this.home}
                onCancel={this.home}
            >
                {this.l10n('SESSION_EXPIRE')}
            </Confirm>
        );
    }

    return (
        <div onClick={this._handleUserActivity}>
            {warning}
            {expire}
            {this.props.children}
        </div>
    );
}
